module.exports = __webpack_public_path__ + "img/p2-57.8bb7ad8f.png";